module.exports = __webpack_public_path__ + "static/media/earnedInADay_100000_250000.a9d92942.png";